'use strict';
import angular from 'angular';
import './product.widget.components';
import './product.widget.services';

angular.module('design.widget.product', [
    'product.widget.components',
    'product.widget.services',
]);